import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import RichTextEditor from '../../components/RichTextEditor';
import './ModifierVente.css';

import api from '../../api';

const ModifierVente = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedImages, setSelectedImages] = useState([]);

  const [formData, setFormData] = useState({
    title: '',
    localisation: { city: '', district: '', name: '', country: '' },
    description: '',
    category: '',
    status: '',
    details: { reference: '', area: '', price: '' },
    autres: [],
    images: []
  });

  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchVente = async () => {
      try {
        //const res = await axios.get(`http://localhost:5000/api/sales/${id}`);
        const res = await api.get(`/sales/${id}`); // Utilisation de l'API
        setFormData(res.data);
        setSelectedImages(res.data.images || []);
      } catch (err) {
        console.error('Erreur de chargement :', err);
      }
    };
    fetchVente();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('localisation.')) {
      const key = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        localisation: { ...prev.localisation, [key]: value }
      }));
    } else if (name.includes('details.')) {
      const key = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        details: { ...prev.details, [key]: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  /*const handleFileChange = (e) => {
    setFiles(e.target.files);
  };*/
  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles(newFiles);
    setSelectedImages(prev => [...prev, ...newFiles]);
  };

  const extractPublicId = (url) => {
    const parts = url.split('/');
    const filename = parts[parts.length - 1];
    return `sales/${filename.split('.')[0]}`;
  };



  const convertFilesToBase64 = (files) => {
    const promises = Array.from(files).map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });
    return Promise.all(promises);
  };
  

  /*const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append('title', formData.title);
    form.append('description', formData.description);
    form.append('category', formData.category);
    form.append('status', formData.status);
    form.append('localisation', JSON.stringify(formData.localisation));
    form.append('details', JSON.stringify(formData.details));
    form.append('autres', JSON.stringify(formData.autres));
    for (let i = 0; i < files.length; i++) {
      form.append('images', files[i]);
    }

    try {
      //await axios.put(`http://localhost:5000/api/sales/${id}`, form, {
      await api.put(`/sales/${id}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert('Vente modifiée avec succès');
      navigate('/ventes');
    } catch (err) {
      console.error('Erreur lors de la mise à jour :', err);
      alert('Erreur lors de la mise à jour');
    }
  };*/
  /*const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Convertir les fichiers en base64
    const base64Images = await Promise.all(
      Array.from(files).map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result); // PAS d'ajout manuel de "data:image/..."
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      })
    );    
  
    // Construire le payload
    const payload = {
      ...formData,
      localisation: JSON.stringify(formData.localisation),
      details: JSON.stringify(formData.details),
      autres: JSON.stringify(formData.autres),
      images: base64Images, // tableau de strings base64
    };

    console.log("Payload envoyé :", payload);

    try {
      await api.put(`/sales/${id}`, payload);
      alert('Vente modifiée avec succès');
      navigate('/ventes');
    } catch (err) {
      console.error('Erreur lors de la mise à jour :', err);
      alert('Erreur lors de la mise à jour');
    }
  };*/
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const uploadForm = new FormData();

      // Sépare les fichiers locaux (File) des URL Cloudinary
      const newFiles = selectedImages.filter((img) => img instanceof File);
      const oldUrls = selectedImages.filter((img) => typeof img === 'string');

      // Ajoute les nouveaux fichiers à uploader
      newFiles.forEach((file) => {
        uploadForm.append('images', file);
      });

      let uploadedImages = [];
      if (newFiles.length > 0) {
        uploadForm.append('type', 'sales');
        const uploadRes = await api.post('/upload', uploadForm);
        uploadedImages = uploadRes.data.uploadedImages; // [{ url, publicId }]
      }

      const oldImages = oldUrls.map((url) => ({
        url,
        publicId: extractPublicId(url),
      }));

      const finalImages = [...oldImages, ...uploadedImages];

      const saleData = {
        ...formData,
        details: {
          ...formData.details,
          price: parseFloat(formData.details.price.toString().replace(/[^\d.]/g, ''))
        },
        images: finalImages,
      };

      await api.put(`/sales/${id}`, saleData, {
        headers: { 'Content-Type': 'application/json' },
      });

      alert("La vente a été modifiée avec succès !");
      navigate('/ventes');
    } catch (error) {
      console.error('Erreur lors de la modification :', error.response?.data || error);
      alert("Une erreur est survenue lors de la mise à jour.");
    }
  };


  
  

  return (
    <div className="modifier-vente-flex">
      <div className="modifier-vente-container">
        <h2>Modifier la vente</h2>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <input type="text" name="title" value={formData.title} onChange={handleChange} placeholder="Titre" required />
          <RichTextEditor
            value={formData.description}
            onChange={(value) => setFormData((prev) => ({ ...prev, description: value }))}
            placeholder="Description"
          />

          <input type="text" name="localisation.city" value={formData.localisation.city} onChange={handleChange} placeholder="Ville" />
          <input type="text" name="localisation.district" value={formData.localisation.district} onChange={handleChange} placeholder="Quartier" />
          <input type="text" name="localisation.name" value={formData.localisation.name} onChange={handleChange} placeholder="Adresse" />
          <input type="text" name="localisation.country" value={formData.localisation.country} onChange={handleChange} placeholder="Pays" />

          {/*<input type="text" name="category" value={formData.category} onChange={handleChange} placeholder="Catégorie" required />*/}
          <select name="category" value={formData.category} onChange={handleChange} required>
            <option value="">-- Sélectionner une catégorie --</option>
            <option value="Terrains">Terrains</option>
            <option value="Maisons">Maisons</option>
            <option value="Appartements">Appartements</option>
            <option value="Champs">Champs</option>
          </select>
          <input type="text" name="status" value={formData.status} onChange={handleChange} placeholder="Statut" />

          <input type="text" name="details.reference" value={formData.details.reference} disabled placeholder="Référence" />
          <input type="text" name="details.area" value={formData.details.area} onChange={handleChange} placeholder="Surface" />
          <input type="number" name="details.price" value={formData.details.price} onChange={handleChange} placeholder="Prix" required />

          <input type="file" multiple onChange={handleFileChange} />

          <button type="submit">Modifier</button>
        </form>
      </div>

      <div className="modifier-vente-container">
        <h2>Détails non modifiables</h2>
        <form>
          <input type="text" name="title" value={formData.title} disabled placeholder="Titre" />
          <div className="rich-description-preview" dangerouslySetInnerHTML={{ __html: formData.description }} />

          <input type="text" name="localisation.city" value={formData.localisation.city} disabled placeholder="Ville" />
          <input type="text" name="localisation.district" value={formData.localisation.district} disabled placeholder="Quartier" />
          <input type="text" name="localisation.name" value={formData.localisation.name} disabled placeholder="Adresse" />
          <input type="text" name="localisation.country" value={formData.localisation.country} disabled placeholder="Pays" />

          <input type="text" name="category" value={formData.category} disabled placeholder="Catégorie" />
          <input type="text" name="status" value={formData.status} disabled placeholder="Statut" />

          <input type="text" name="details.reference" value={formData.details.reference} disabled placeholder="Référence" />
          <input type="text" name="details.area" value={formData.details.area} disabled placeholder="Surface" />
          <input className="last-input" type="number" name="details.price" value={formData.details.price} disabled placeholder="Prix" />
        </form>
      </div>

    </div>
  );
};

export default ModifierVente;
